// 月額コース解除処理をまとめたカスタムフック
import { useMutation } from '@tanstack/react-query'
import { useToast } from '@chakra-ui/react'
import { unregisterMonthlyCourseApi as unregisterMonthlyCourseWithCreditApi, unregisterMonthlyCourseWithPayApi } from '@!/Api/monthlyCourse'

export const useMonthlyCourseUnregister = () => {
  const toast = useToast()

  const handleSuccess = () => {
    window.location.href = '/user/monthly_course_unregister/complete'
  }

  const handleError = (error) => {
    let title, description

    switch (error.data?.error) {
      case 'NOT_REGISTERED':
        title = '月額コースに登録されていません'
        description = '問題が解決しない場合はお問い合わせください。'
        break
      case 'FAILED_UNREGISTER':
        title = '月額コースの解除に失敗しました'
        description = 'しばらく時間をおいて再度お試しください。'
        break
      case 'INVALID_PARAMS':
      default:
        title = 'エラーが発生しました'
        description = 'しばらく時間をおいて再度お試しください。'
    }

    toast({
      title,
      description,
      status: 'error',
      duration: 5000,
      isClosable: true,
    })
  }

  // クレジット決済解除
  const unregisterWithCredit = useMutation({
    mutationFn: (params) => unregisterMonthlyCourseWithCreditApi(params),
    onSuccess: handleSuccess,
    onError: handleError,
  })

  // キャリア決済・PayPay決済解除
  const unregisterWithPay = useMutation({
    mutationFn: (params) => unregisterMonthlyCourseWithPayApi(params),
    onSuccess: handleSuccess,
    onError: handleError,
  })

  const executeUnregister = (orderId, settlementType) => {
    const params = { order_id: orderId }
    if (settlementType === 'web_credit') {
      unregisterWithCredit.mutate(params)
    } else if (settlementType === 'docomo' || settlementType === 'au' || settlementType === 'paypay') {
      unregisterWithPay.mutate(params)
    }
  }

  return {
    executeUnregister,
    isUnregistering: unregisterWithCredit.isPending || unregisterWithPay.isPending,
    isUnregisterError: unregisterWithCredit.isError || unregisterWithPay.isError,
  }
}
